<template>
    <div class="advertising-modal-advanced-config-captive-forms-filter-table">      
      <v-data-table class="advertising-modal-advanced-config-captive-forms-filter-table-body"
                    :headers="headers"
                    :items="captiveFormsList"
                    :loading="loading"
                    :hide-actions="true"
                    :no-data-text="$t('message.generics.message.noResultsFound')"
                    :no-results-text="$t('message.generics.message.noData')">
  
        <template slot="items"
                  slot-scope="props">
          <advertising-modal-advanced-config-captive-forms-filter-table-item :captiveFormItem="props.item"
                                                                             :value="value"                                     
                                                                             @change="setSelectedId"/>                                    
        </template>
      </v-data-table>  
      
    </div>
  </template>
  
  <script>
  import AdvertisingModalAdvancedConfigCaptiveFormsFilterTableItem from "./item/AdvertisingModalAdvancedConfigCaptiveFormsFilterTableItem.vue";
  
  export default {
    components: {
      AdvertisingModalAdvancedConfigCaptiveFormsFilterTableItem
    },
    data() {
      return {
        page: 0,
        showPlanAddForm: false,
      };
    },
  
    computed: {
      headers() {
          return [
              { text: "", value: "", sortable: false, width: 50 },
              { text: this.$t('message.generics.message.name'), value: "name", sortable: false },
              { text: this.$t('message.loginPersonalize.message.key'), value: "key", sortable: false },             
          ]
      }
    },
  
    props: {
      captiveFormsList: {
        type: Array,
        required: false,
        default: () => {
          return [];
        },
      },
      value: {
        type: Array,
      },
      loading: {
        type: Boolean,
        default: false,
      },      
    },
    methods: {      
      setSelectedId(value) {  
        this.$emit("input", value);
      },      
      emitChanged() {
        this.$emit("changed");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .advertising-modal-advanced-config-captive-forms-filter-table {
    margin: 15px 0;
    width: 100%;    
  
    .advertising-modal-advanced-config-captive-forms-filter-table-body {
      padding: 0 20px 10px;
      border: 2px solid #c4c4c4;
      border-radius: 8px;
    }
  }
  </style>
  